export default __webpack_public_path__ + "sos.34eed77d.png";